import React, { Component } from 'react';

class VersionDetails extends Component {  
    render() {
        let i = 0;
        return (
            <td><ul>{this.props.details.map((detail) => <li key={i++}>{detail}</li>)}</ul></td>
        );
    }
}

export default VersionDetails;